module.exports = __webpack_public_path__ + "img/fig17.61b7fd6b.jpg";